
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(34);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(true);
            return ()=>{
                if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== dialogs || $[29] !== extension || $[30] !== onInitialRender || $[31] !== t11 || $[32] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12,
            dialogs: dialogs
        }));
        $[28] = dialogs;
        $[29] = extension;
        $[30] = onInitialRender;
        $[31] = t11;
        $[32] = t12;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("1K8CI"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("g6LfG"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("kpO9x"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("f6hSf"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("cXity"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5f4Np"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("90m5V"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("iXMnL"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("1NlRd"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("1QZfp"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("glit8"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("eQgk5"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("1K8CI", function(module, exports) {

let $1450c6c18f601beb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1450c6c18f601beb$var$load("2YffH"),
    $1450c6c18f601beb$var$load("8Kivm"),
    $1450c6c18f601beb$var$load("cf5vC"),
    $1450c6c18f601beb$var$load("g4Z5V"),
    $1450c6c18f601beb$var$load("gHOqr"),
    $1450c6c18f601beb$var$load("iQ0Jm"),
    $1450c6c18f601beb$var$load("coJiW"),
    $1450c6c18f601beb$var$load("6SW0d"),
    $1450c6c18f601beb$var$load("6RpMD"),
    $1450c6c18f601beb$var$load("h4Nf7"),
    $1450c6c18f601beb$var$load("7f9Fz"),
    $1450c6c18f601beb$var$load("8YSo7"),
    $1450c6c18f601beb$var$load("9AHrA"),
    $1450c6c18f601beb$var$load("2spqH"),
    $1450c6c18f601beb$var$load("gWSdF"),
    $1450c6c18f601beb$var$load("6FuHS"),
    $1450c6c18f601beb$var$load("eyaRC"),
    $1450c6c18f601beb$var$load("g9CVe"),
    $1450c6c18f601beb$var$load("aeEUI"),
    $1450c6c18f601beb$var$load("iXzmH"),
    $1450c6c18f601beb$var$load("65c4i"),
    $1450c6c18f601beb$var$load("6wr18"),
    $1450c6c18f601beb$var$load("kjZZD"),
    $1450c6c18f601beb$var$load("3TTZL"),
    $1450c6c18f601beb$var$load("eHDb1"),
    $1450c6c18f601beb$var$load("2zUEf"),
    $1450c6c18f601beb$var$load("37ldp"),
    $1450c6c18f601beb$var$load("awqCy"),
    $1450c6c18f601beb$var$load("kHOMt"),
    $1450c6c18f601beb$var$load("hhss7"),
    $1450c6c18f601beb$var$load("aqsij"),
    $1450c6c18f601beb$var$load("3kIJ4"),
    $1450c6c18f601beb$var$load("iZU4p"),
    $1450c6c18f601beb$var$load("Wowvf"),
    $1450c6c18f601beb$var$load("dS0Pr"),
    $1450c6c18f601beb$var$load("huYla"),
    $1450c6c18f601beb$var$load("f1NVy"),
    $1450c6c18f601beb$var$load("2haIE"),
    $1450c6c18f601beb$var$load("9K4jq"),
    $1450c6c18f601beb$var$load("let0D"),
    $1450c6c18f601beb$var$load("6EQss"),
    $1450c6c18f601beb$var$load("6M36W"),
    $1450c6c18f601beb$var$load("ffEVr"),
    $1450c6c18f601beb$var$load("kUbUu"),
    $1450c6c18f601beb$var$load("9ftJe"),
    $1450c6c18f601beb$var$load("hUIij"),
    $1450c6c18f601beb$var$load("hX3A6"),
    $1450c6c18f601beb$var$load("lnKog"),
    $1450c6c18f601beb$var$load("7Omhy"),
    $1450c6c18f601beb$var$load("kC80R"),
    $1450c6c18f601beb$var$load("7EorR"),
    $1450c6c18f601beb$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("g6LfG", function(module, exports) {

let $bba1dc1ec0ef9d10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bba1dc1ec0ef9d10$var$load("2YffH"),
    $bba1dc1ec0ef9d10$var$load("8Kivm"),
    $bba1dc1ec0ef9d10$var$load("cf5vC"),
    $bba1dc1ec0ef9d10$var$load("g4Z5V"),
    $bba1dc1ec0ef9d10$var$load("gHOqr"),
    $bba1dc1ec0ef9d10$var$load("iQ0Jm"),
    $bba1dc1ec0ef9d10$var$load("coJiW"),
    $bba1dc1ec0ef9d10$var$load("6SW0d"),
    $bba1dc1ec0ef9d10$var$load("6RpMD"),
    $bba1dc1ec0ef9d10$var$load("h4Nf7"),
    $bba1dc1ec0ef9d10$var$load("7f9Fz"),
    $bba1dc1ec0ef9d10$var$load("8YSo7"),
    $bba1dc1ec0ef9d10$var$load("9AHrA"),
    $bba1dc1ec0ef9d10$var$load("2spqH"),
    $bba1dc1ec0ef9d10$var$load("gWSdF"),
    $bba1dc1ec0ef9d10$var$load("6FuHS"),
    $bba1dc1ec0ef9d10$var$load("eyaRC"),
    $bba1dc1ec0ef9d10$var$load("g9CVe"),
    $bba1dc1ec0ef9d10$var$load("aeEUI"),
    $bba1dc1ec0ef9d10$var$load("iXzmH"),
    $bba1dc1ec0ef9d10$var$load("65c4i"),
    $bba1dc1ec0ef9d10$var$load("6wr18"),
    $bba1dc1ec0ef9d10$var$load("kjZZD"),
    $bba1dc1ec0ef9d10$var$load("3TTZL"),
    $bba1dc1ec0ef9d10$var$load("eHDb1"),
    $bba1dc1ec0ef9d10$var$load("2zUEf"),
    $bba1dc1ec0ef9d10$var$load("37ldp"),
    $bba1dc1ec0ef9d10$var$load("awqCy"),
    $bba1dc1ec0ef9d10$var$load("kHOMt"),
    $bba1dc1ec0ef9d10$var$load("hhss7"),
    $bba1dc1ec0ef9d10$var$load("aqsij"),
    $bba1dc1ec0ef9d10$var$load("3kIJ4"),
    $bba1dc1ec0ef9d10$var$load("iZU4p"),
    $bba1dc1ec0ef9d10$var$load("Wowvf"),
    $bba1dc1ec0ef9d10$var$load("dS0Pr"),
    $bba1dc1ec0ef9d10$var$load("huYla"),
    $bba1dc1ec0ef9d10$var$load("f1NVy"),
    $bba1dc1ec0ef9d10$var$load("2haIE"),
    $bba1dc1ec0ef9d10$var$load("9K4jq"),
    $bba1dc1ec0ef9d10$var$load("let0D"),
    $bba1dc1ec0ef9d10$var$load("6EQss"),
    $bba1dc1ec0ef9d10$var$load("6M36W"),
    $bba1dc1ec0ef9d10$var$load("ffEVr"),
    $bba1dc1ec0ef9d10$var$load("kUbUu"),
    $bba1dc1ec0ef9d10$var$load("9ftJe"),
    $bba1dc1ec0ef9d10$var$load("hUIij"),
    $bba1dc1ec0ef9d10$var$load("hX3A6"),
    $bba1dc1ec0ef9d10$var$load("lnKog"),
    $bba1dc1ec0ef9d10$var$load("7Omhy"),
    $bba1dc1ec0ef9d10$var$load("kC80R"),
    $bba1dc1ec0ef9d10$var$load("7EorR"),
    $bba1dc1ec0ef9d10$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("kpO9x", function(module, exports) {

let $edcd0bbb3e48499f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $edcd0bbb3e48499f$var$load("2YffH"),
    $edcd0bbb3e48499f$var$load("8Kivm"),
    $edcd0bbb3e48499f$var$load("cf5vC"),
    $edcd0bbb3e48499f$var$load("g4Z5V"),
    $edcd0bbb3e48499f$var$load("gHOqr"),
    $edcd0bbb3e48499f$var$load("iQ0Jm"),
    $edcd0bbb3e48499f$var$load("coJiW"),
    $edcd0bbb3e48499f$var$load("6SW0d"),
    $edcd0bbb3e48499f$var$load("6RpMD"),
    $edcd0bbb3e48499f$var$load("h4Nf7"),
    $edcd0bbb3e48499f$var$load("7f9Fz"),
    $edcd0bbb3e48499f$var$load("8YSo7"),
    $edcd0bbb3e48499f$var$load("9AHrA"),
    $edcd0bbb3e48499f$var$load("2spqH"),
    $edcd0bbb3e48499f$var$load("gWSdF"),
    $edcd0bbb3e48499f$var$load("6FuHS"),
    $edcd0bbb3e48499f$var$load("eyaRC"),
    $edcd0bbb3e48499f$var$load("g9CVe"),
    $edcd0bbb3e48499f$var$load("aeEUI"),
    $edcd0bbb3e48499f$var$load("iXzmH"),
    $edcd0bbb3e48499f$var$load("65c4i"),
    $edcd0bbb3e48499f$var$load("6wr18"),
    $edcd0bbb3e48499f$var$load("kjZZD"),
    $edcd0bbb3e48499f$var$load("3TTZL"),
    $edcd0bbb3e48499f$var$load("eHDb1"),
    $edcd0bbb3e48499f$var$load("2zUEf"),
    $edcd0bbb3e48499f$var$load("37ldp"),
    $edcd0bbb3e48499f$var$load("awqCy"),
    $edcd0bbb3e48499f$var$load("kHOMt"),
    $edcd0bbb3e48499f$var$load("hhss7"),
    $edcd0bbb3e48499f$var$load("aqsij"),
    $edcd0bbb3e48499f$var$load("3kIJ4"),
    $edcd0bbb3e48499f$var$load("iZU4p"),
    $edcd0bbb3e48499f$var$load("Wowvf"),
    $edcd0bbb3e48499f$var$load("dS0Pr"),
    $edcd0bbb3e48499f$var$load("huYla"),
    $edcd0bbb3e48499f$var$load("f1NVy"),
    $edcd0bbb3e48499f$var$load("2haIE"),
    $edcd0bbb3e48499f$var$load("9K4jq"),
    $edcd0bbb3e48499f$var$load("let0D"),
    $edcd0bbb3e48499f$var$load("6EQss"),
    $edcd0bbb3e48499f$var$load("6M36W"),
    $edcd0bbb3e48499f$var$load("ffEVr"),
    $edcd0bbb3e48499f$var$load("kUbUu"),
    $edcd0bbb3e48499f$var$load("9ftJe"),
    $edcd0bbb3e48499f$var$load("hUIij"),
    $edcd0bbb3e48499f$var$load("hX3A6"),
    $edcd0bbb3e48499f$var$load("lnKog"),
    $edcd0bbb3e48499f$var$load("7Omhy"),
    $edcd0bbb3e48499f$var$load("kC80R"),
    $edcd0bbb3e48499f$var$load("7EorR"),
    $edcd0bbb3e48499f$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("f6hSf", function(module, exports) {

let $afe547f6b425a0f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afe547f6b425a0f1$var$load("6FuHS"),
    $afe547f6b425a0f1$var$load("eyaRC"),
    $afe547f6b425a0f1$var$load("2YffH"),
    $afe547f6b425a0f1$var$load("cf5vC"),
    $afe547f6b425a0f1$var$load("g4Z5V"),
    $afe547f6b425a0f1$var$load("gHOqr"),
    $afe547f6b425a0f1$var$load("6SW0d"),
    $afe547f6b425a0f1$var$load("6RpMD"),
    $afe547f6b425a0f1$var$load("h4Nf7"),
    $afe547f6b425a0f1$var$load("7f9Fz"),
    $afe547f6b425a0f1$var$load("8YSo7"),
    $afe547f6b425a0f1$var$load("9AHrA"),
    $afe547f6b425a0f1$var$load("2spqH"),
    $afe547f6b425a0f1$var$load("gWSdF"),
    $afe547f6b425a0f1$var$load("g9CVe"),
    $afe547f6b425a0f1$var$load("aeEUI"),
    $afe547f6b425a0f1$var$load("iXzmH"),
    $afe547f6b425a0f1$var$load("65c4i"),
    $afe547f6b425a0f1$var$load("6wr18"),
    $afe547f6b425a0f1$var$load("kjZZD"),
    $afe547f6b425a0f1$var$load("3TTZL"),
    $afe547f6b425a0f1$var$load("eHDb1"),
    $afe547f6b425a0f1$var$load("2zUEf"),
    $afe547f6b425a0f1$var$load("37ldp"),
    $afe547f6b425a0f1$var$load("awqCy"),
    $afe547f6b425a0f1$var$load("kHOMt"),
    $afe547f6b425a0f1$var$load("hhss7"),
    $afe547f6b425a0f1$var$load("aqsij"),
    $afe547f6b425a0f1$var$load("3kIJ4"),
    $afe547f6b425a0f1$var$load("iZU4p"),
    $afe547f6b425a0f1$var$load("Wowvf"),
    $afe547f6b425a0f1$var$load("dS0Pr"),
    $afe547f6b425a0f1$var$load("huYla"),
    $afe547f6b425a0f1$var$load("f1NVy"),
    $afe547f6b425a0f1$var$load("2haIE"),
    $afe547f6b425a0f1$var$load("9K4jq"),
    $afe547f6b425a0f1$var$load("let0D"),
    $afe547f6b425a0f1$var$load("6EQss"),
    $afe547f6b425a0f1$var$load("6M36W"),
    $afe547f6b425a0f1$var$load("hUIij"),
    $afe547f6b425a0f1$var$load("ffEVr"),
    $afe547f6b425a0f1$var$load("kUbUu"),
    $afe547f6b425a0f1$var$load("9ftJe"),
    $afe547f6b425a0f1$var$load("7Omhy"),
    $afe547f6b425a0f1$var$load("kC80R"),
    $afe547f6b425a0f1$var$load("7EorR"),
    $afe547f6b425a0f1$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("cXity", function(module, exports) {

let $96e953a22c0f40d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $96e953a22c0f40d6$var$load("6FuHS"),
    $96e953a22c0f40d6$var$load("eyaRC"),
    $96e953a22c0f40d6$var$load("2YffH"),
    $96e953a22c0f40d6$var$load("cf5vC"),
    $96e953a22c0f40d6$var$load("g4Z5V"),
    $96e953a22c0f40d6$var$load("gHOqr"),
    $96e953a22c0f40d6$var$load("6SW0d"),
    $96e953a22c0f40d6$var$load("6RpMD"),
    $96e953a22c0f40d6$var$load("h4Nf7"),
    $96e953a22c0f40d6$var$load("7f9Fz"),
    $96e953a22c0f40d6$var$load("8YSo7"),
    $96e953a22c0f40d6$var$load("9AHrA"),
    $96e953a22c0f40d6$var$load("2spqH"),
    $96e953a22c0f40d6$var$load("gWSdF"),
    $96e953a22c0f40d6$var$load("g9CVe"),
    $96e953a22c0f40d6$var$load("aeEUI"),
    $96e953a22c0f40d6$var$load("iXzmH"),
    $96e953a22c0f40d6$var$load("65c4i"),
    $96e953a22c0f40d6$var$load("6wr18"),
    $96e953a22c0f40d6$var$load("kjZZD"),
    $96e953a22c0f40d6$var$load("3TTZL"),
    $96e953a22c0f40d6$var$load("eHDb1"),
    $96e953a22c0f40d6$var$load("2zUEf"),
    $96e953a22c0f40d6$var$load("37ldp"),
    $96e953a22c0f40d6$var$load("awqCy"),
    $96e953a22c0f40d6$var$load("kHOMt"),
    $96e953a22c0f40d6$var$load("hhss7"),
    $96e953a22c0f40d6$var$load("aqsij"),
    $96e953a22c0f40d6$var$load("3kIJ4"),
    $96e953a22c0f40d6$var$load("iZU4p"),
    $96e953a22c0f40d6$var$load("Wowvf"),
    $96e953a22c0f40d6$var$load("dS0Pr"),
    $96e953a22c0f40d6$var$load("huYla"),
    $96e953a22c0f40d6$var$load("f1NVy"),
    $96e953a22c0f40d6$var$load("2haIE"),
    $96e953a22c0f40d6$var$load("9K4jq"),
    $96e953a22c0f40d6$var$load("let0D"),
    $96e953a22c0f40d6$var$load("6EQss"),
    $96e953a22c0f40d6$var$load("6M36W"),
    $96e953a22c0f40d6$var$load("hUIij"),
    $96e953a22c0f40d6$var$load("ffEVr"),
    $96e953a22c0f40d6$var$load("kUbUu"),
    $96e953a22c0f40d6$var$load("9ftJe"),
    $96e953a22c0f40d6$var$load("7Omhy"),
    $96e953a22c0f40d6$var$load("kC80R"),
    $96e953a22c0f40d6$var$load("7EorR"),
    $96e953a22c0f40d6$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("5f4Np", function(module, exports) {

let $3d1212d566f96e50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d1212d566f96e50$var$load("6FuHS"),
    $3d1212d566f96e50$var$load("eyaRC"),
    $3d1212d566f96e50$var$load("2YffH"),
    $3d1212d566f96e50$var$load("cf5vC"),
    $3d1212d566f96e50$var$load("g4Z5V"),
    $3d1212d566f96e50$var$load("gHOqr"),
    $3d1212d566f96e50$var$load("6SW0d"),
    $3d1212d566f96e50$var$load("6RpMD"),
    $3d1212d566f96e50$var$load("h4Nf7"),
    $3d1212d566f96e50$var$load("7f9Fz"),
    $3d1212d566f96e50$var$load("8YSo7"),
    $3d1212d566f96e50$var$load("9AHrA"),
    $3d1212d566f96e50$var$load("2spqH"),
    $3d1212d566f96e50$var$load("gWSdF"),
    $3d1212d566f96e50$var$load("g9CVe"),
    $3d1212d566f96e50$var$load("aeEUI"),
    $3d1212d566f96e50$var$load("iXzmH"),
    $3d1212d566f96e50$var$load("65c4i"),
    $3d1212d566f96e50$var$load("6wr18"),
    $3d1212d566f96e50$var$load("kjZZD"),
    $3d1212d566f96e50$var$load("3TTZL"),
    $3d1212d566f96e50$var$load("eHDb1"),
    $3d1212d566f96e50$var$load("2zUEf"),
    $3d1212d566f96e50$var$load("37ldp"),
    $3d1212d566f96e50$var$load("awqCy"),
    $3d1212d566f96e50$var$load("kHOMt"),
    $3d1212d566f96e50$var$load("hhss7"),
    $3d1212d566f96e50$var$load("aqsij"),
    $3d1212d566f96e50$var$load("3kIJ4"),
    $3d1212d566f96e50$var$load("iZU4p"),
    $3d1212d566f96e50$var$load("Wowvf"),
    $3d1212d566f96e50$var$load("dS0Pr"),
    $3d1212d566f96e50$var$load("huYla"),
    $3d1212d566f96e50$var$load("f1NVy"),
    $3d1212d566f96e50$var$load("2haIE"),
    $3d1212d566f96e50$var$load("9K4jq"),
    $3d1212d566f96e50$var$load("let0D"),
    $3d1212d566f96e50$var$load("6EQss"),
    $3d1212d566f96e50$var$load("6M36W"),
    $3d1212d566f96e50$var$load("hUIij"),
    $3d1212d566f96e50$var$load("ffEVr"),
    $3d1212d566f96e50$var$load("kUbUu"),
    $3d1212d566f96e50$var$load("9ftJe"),
    $3d1212d566f96e50$var$load("7Omhy"),
    $3d1212d566f96e50$var$load("kC80R"),
    $3d1212d566f96e50$var$load("7EorR"),
    $3d1212d566f96e50$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("90m5V", function(module, exports) {

let $68e540a689f491bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68e540a689f491bd$var$load("6FuHS"),
    $68e540a689f491bd$var$load("eyaRC"),
    $68e540a689f491bd$var$load("2YffH"),
    $68e540a689f491bd$var$load("cf5vC"),
    $68e540a689f491bd$var$load("g4Z5V"),
    $68e540a689f491bd$var$load("gHOqr"),
    $68e540a689f491bd$var$load("6SW0d"),
    $68e540a689f491bd$var$load("6RpMD"),
    $68e540a689f491bd$var$load("h4Nf7"),
    $68e540a689f491bd$var$load("7f9Fz"),
    $68e540a689f491bd$var$load("8YSo7"),
    $68e540a689f491bd$var$load("9AHrA"),
    $68e540a689f491bd$var$load("2spqH"),
    $68e540a689f491bd$var$load("gWSdF"),
    $68e540a689f491bd$var$load("g9CVe"),
    $68e540a689f491bd$var$load("aeEUI"),
    $68e540a689f491bd$var$load("iXzmH"),
    $68e540a689f491bd$var$load("65c4i"),
    $68e540a689f491bd$var$load("6wr18"),
    $68e540a689f491bd$var$load("kjZZD"),
    $68e540a689f491bd$var$load("3TTZL"),
    $68e540a689f491bd$var$load("eHDb1"),
    $68e540a689f491bd$var$load("2zUEf"),
    $68e540a689f491bd$var$load("37ldp"),
    $68e540a689f491bd$var$load("awqCy"),
    $68e540a689f491bd$var$load("kHOMt"),
    $68e540a689f491bd$var$load("hhss7"),
    $68e540a689f491bd$var$load("aqsij"),
    $68e540a689f491bd$var$load("3kIJ4"),
    $68e540a689f491bd$var$load("iZU4p"),
    $68e540a689f491bd$var$load("Wowvf"),
    $68e540a689f491bd$var$load("dS0Pr"),
    $68e540a689f491bd$var$load("huYla"),
    $68e540a689f491bd$var$load("f1NVy"),
    $68e540a689f491bd$var$load("2haIE"),
    $68e540a689f491bd$var$load("9K4jq"),
    $68e540a689f491bd$var$load("let0D"),
    $68e540a689f491bd$var$load("6EQss"),
    $68e540a689f491bd$var$load("6M36W"),
    $68e540a689f491bd$var$load("ffEVr"),
    $68e540a689f491bd$var$load("kUbUu"),
    $68e540a689f491bd$var$load("9ftJe"),
    $68e540a689f491bd$var$load("hUIij"),
    $68e540a689f491bd$var$load("hX3A6"),
    $68e540a689f491bd$var$load("lnKog"),
    $68e540a689f491bd$var$load("7Omhy"),
    $68e540a689f491bd$var$load("kC80R"),
    $68e540a689f491bd$var$load("7EorR"),
    $68e540a689f491bd$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("iXMnL", function(module, exports) {

let $dce344605def7289$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dce344605def7289$var$load("2YffH"),
    $dce344605def7289$var$load("cf5vC"),
    $dce344605def7289$var$load("g4Z5V"),
    $dce344605def7289$var$load("gHOqr"),
    $dce344605def7289$var$load("coJiW"),
    $dce344605def7289$var$load("6SW0d"),
    $dce344605def7289$var$load("6RpMD"),
    $dce344605def7289$var$load("h4Nf7"),
    $dce344605def7289$var$load("7f9Fz"),
    $dce344605def7289$var$load("8YSo7"),
    $dce344605def7289$var$load("9AHrA"),
    $dce344605def7289$var$load("2spqH"),
    $dce344605def7289$var$load("gWSdF"),
    $dce344605def7289$var$load("6FuHS"),
    $dce344605def7289$var$load("eyaRC"),
    $dce344605def7289$var$load("g9CVe"),
    $dce344605def7289$var$load("aeEUI"),
    $dce344605def7289$var$load("iXzmH"),
    $dce344605def7289$var$load("65c4i"),
    $dce344605def7289$var$load("6wr18"),
    $dce344605def7289$var$load("kjZZD"),
    $dce344605def7289$var$load("3TTZL"),
    $dce344605def7289$var$load("eHDb1"),
    $dce344605def7289$var$load("2zUEf"),
    $dce344605def7289$var$load("37ldp"),
    $dce344605def7289$var$load("dTsOE"),
    $dce344605def7289$var$load("awqCy"),
    $dce344605def7289$var$load("kHOMt"),
    $dce344605def7289$var$load("hhss7"),
    $dce344605def7289$var$load("aqsij"),
    $dce344605def7289$var$load("3kIJ4"),
    $dce344605def7289$var$load("iZU4p"),
    $dce344605def7289$var$load("Wowvf"),
    $dce344605def7289$var$load("dS0Pr"),
    $dce344605def7289$var$load("huYla"),
    $dce344605def7289$var$load("f1NVy"),
    $dce344605def7289$var$load("2haIE"),
    $dce344605def7289$var$load("9K4jq"),
    $dce344605def7289$var$load("let0D"),
    $dce344605def7289$var$load("6EQss"),
    $dce344605def7289$var$load("6M36W"),
    $dce344605def7289$var$load("ffEVr"),
    $dce344605def7289$var$load("kUbUu"),
    $dce344605def7289$var$load("9ftJe"),
    $dce344605def7289$var$load("hUIij"),
    $dce344605def7289$var$load("hX3A6"),
    $dce344605def7289$var$load("lnKog"),
    $dce344605def7289$var$load("7Omhy"),
    $dce344605def7289$var$load("kC80R"),
    $dce344605def7289$var$load("7EorR"),
    $dce344605def7289$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("1NlRd", function(module, exports) {

let $14eb52789405e734$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14eb52789405e734$var$load("2YffH"),
    $14eb52789405e734$var$load("cf5vC"),
    $14eb52789405e734$var$load("g4Z5V"),
    $14eb52789405e734$var$load("gHOqr"),
    $14eb52789405e734$var$load("coJiW"),
    $14eb52789405e734$var$load("6SW0d"),
    $14eb52789405e734$var$load("6RpMD"),
    $14eb52789405e734$var$load("h4Nf7"),
    $14eb52789405e734$var$load("7f9Fz"),
    $14eb52789405e734$var$load("8YSo7"),
    $14eb52789405e734$var$load("9AHrA"),
    $14eb52789405e734$var$load("2spqH"),
    $14eb52789405e734$var$load("gWSdF"),
    $14eb52789405e734$var$load("6FuHS"),
    $14eb52789405e734$var$load("eyaRC"),
    $14eb52789405e734$var$load("g9CVe"),
    $14eb52789405e734$var$load("aeEUI"),
    $14eb52789405e734$var$load("iXzmH"),
    $14eb52789405e734$var$load("65c4i"),
    $14eb52789405e734$var$load("6wr18"),
    $14eb52789405e734$var$load("kjZZD"),
    $14eb52789405e734$var$load("3TTZL"),
    $14eb52789405e734$var$load("eHDb1"),
    $14eb52789405e734$var$load("2zUEf"),
    $14eb52789405e734$var$load("37ldp"),
    $14eb52789405e734$var$load("dTsOE"),
    $14eb52789405e734$var$load("awqCy"),
    $14eb52789405e734$var$load("kHOMt"),
    $14eb52789405e734$var$load("hhss7"),
    $14eb52789405e734$var$load("aqsij"),
    $14eb52789405e734$var$load("3kIJ4"),
    $14eb52789405e734$var$load("iZU4p"),
    $14eb52789405e734$var$load("Wowvf"),
    $14eb52789405e734$var$load("dS0Pr"),
    $14eb52789405e734$var$load("huYla"),
    $14eb52789405e734$var$load("f1NVy"),
    $14eb52789405e734$var$load("2haIE"),
    $14eb52789405e734$var$load("9K4jq"),
    $14eb52789405e734$var$load("let0D"),
    $14eb52789405e734$var$load("6EQss"),
    $14eb52789405e734$var$load("6M36W"),
    $14eb52789405e734$var$load("ffEVr"),
    $14eb52789405e734$var$load("kUbUu"),
    $14eb52789405e734$var$load("9ftJe"),
    $14eb52789405e734$var$load("hUIij"),
    $14eb52789405e734$var$load("hX3A6"),
    $14eb52789405e734$var$load("lnKog"),
    $14eb52789405e734$var$load("7Omhy"),
    $14eb52789405e734$var$load("kC80R"),
    $14eb52789405e734$var$load("7EorR"),
    $14eb52789405e734$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("1QZfp", function(module, exports) {

let $159a284295378c92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $159a284295378c92$var$load("6FuHS"),
    $159a284295378c92$var$load("eyaRC"),
    $159a284295378c92$var$load("2YffH"),
    $159a284295378c92$var$load("cf5vC"),
    $159a284295378c92$var$load("g4Z5V"),
    $159a284295378c92$var$load("gHOqr"),
    $159a284295378c92$var$load("6SW0d"),
    $159a284295378c92$var$load("6RpMD"),
    $159a284295378c92$var$load("h4Nf7"),
    $159a284295378c92$var$load("7f9Fz"),
    $159a284295378c92$var$load("8YSo7"),
    $159a284295378c92$var$load("9AHrA"),
    $159a284295378c92$var$load("2spqH"),
    $159a284295378c92$var$load("gWSdF"),
    $159a284295378c92$var$load("g9CVe"),
    $159a284295378c92$var$load("aeEUI"),
    $159a284295378c92$var$load("iXzmH"),
    $159a284295378c92$var$load("65c4i"),
    $159a284295378c92$var$load("6wr18"),
    $159a284295378c92$var$load("kjZZD"),
    $159a284295378c92$var$load("3TTZL"),
    $159a284295378c92$var$load("eHDb1"),
    $159a284295378c92$var$load("2zUEf"),
    $159a284295378c92$var$load("37ldp"),
    $159a284295378c92$var$load("awqCy"),
    $159a284295378c92$var$load("kHOMt"),
    $159a284295378c92$var$load("hhss7"),
    $159a284295378c92$var$load("aqsij"),
    $159a284295378c92$var$load("3kIJ4"),
    $159a284295378c92$var$load("iZU4p"),
    $159a284295378c92$var$load("Wowvf"),
    $159a284295378c92$var$load("dS0Pr"),
    $159a284295378c92$var$load("huYla"),
    $159a284295378c92$var$load("f1NVy"),
    $159a284295378c92$var$load("2haIE"),
    $159a284295378c92$var$load("9K4jq"),
    $159a284295378c92$var$load("let0D"),
    $159a284295378c92$var$load("6EQss"),
    $159a284295378c92$var$load("6M36W"),
    $159a284295378c92$var$load("hUIij"),
    $159a284295378c92$var$load("ffEVr"),
    $159a284295378c92$var$load("kUbUu"),
    $159a284295378c92$var$load("9ftJe"),
    $159a284295378c92$var$load("7Omhy"),
    $159a284295378c92$var$load("kC80R"),
    $159a284295378c92$var$load("7EorR"),
    $159a284295378c92$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("glit8", function(module, exports) {

let $be5cef0f24b910f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be5cef0f24b910f3$var$load("6FuHS"),
    $be5cef0f24b910f3$var$load("eyaRC"),
    $be5cef0f24b910f3$var$load("2YffH"),
    $be5cef0f24b910f3$var$load("cf5vC"),
    $be5cef0f24b910f3$var$load("g4Z5V"),
    $be5cef0f24b910f3$var$load("gHOqr"),
    $be5cef0f24b910f3$var$load("6SW0d"),
    $be5cef0f24b910f3$var$load("6RpMD"),
    $be5cef0f24b910f3$var$load("h4Nf7"),
    $be5cef0f24b910f3$var$load("7f9Fz"),
    $be5cef0f24b910f3$var$load("8YSo7"),
    $be5cef0f24b910f3$var$load("9AHrA"),
    $be5cef0f24b910f3$var$load("2spqH"),
    $be5cef0f24b910f3$var$load("gWSdF"),
    $be5cef0f24b910f3$var$load("g9CVe"),
    $be5cef0f24b910f3$var$load("aeEUI"),
    $be5cef0f24b910f3$var$load("iXzmH"),
    $be5cef0f24b910f3$var$load("65c4i"),
    $be5cef0f24b910f3$var$load("6wr18"),
    $be5cef0f24b910f3$var$load("kjZZD"),
    $be5cef0f24b910f3$var$load("3TTZL"),
    $be5cef0f24b910f3$var$load("eHDb1"),
    $be5cef0f24b910f3$var$load("2zUEf"),
    $be5cef0f24b910f3$var$load("37ldp"),
    $be5cef0f24b910f3$var$load("awqCy"),
    $be5cef0f24b910f3$var$load("kHOMt"),
    $be5cef0f24b910f3$var$load("hhss7"),
    $be5cef0f24b910f3$var$load("aqsij"),
    $be5cef0f24b910f3$var$load("3kIJ4"),
    $be5cef0f24b910f3$var$load("iZU4p"),
    $be5cef0f24b910f3$var$load("Wowvf"),
    $be5cef0f24b910f3$var$load("dS0Pr"),
    $be5cef0f24b910f3$var$load("huYla"),
    $be5cef0f24b910f3$var$load("f1NVy"),
    $be5cef0f24b910f3$var$load("2haIE"),
    $be5cef0f24b910f3$var$load("9K4jq"),
    $be5cef0f24b910f3$var$load("let0D"),
    $be5cef0f24b910f3$var$load("6EQss"),
    $be5cef0f24b910f3$var$load("6M36W"),
    $be5cef0f24b910f3$var$load("ffEVr"),
    $be5cef0f24b910f3$var$load("kUbUu"),
    $be5cef0f24b910f3$var$load("9ftJe"),
    $be5cef0f24b910f3$var$load("hUIij"),
    $be5cef0f24b910f3$var$load("hX3A6"),
    $be5cef0f24b910f3$var$load("lnKog"),
    $be5cef0f24b910f3$var$load("7Omhy"),
    $be5cef0f24b910f3$var$load("kC80R"),
    $be5cef0f24b910f3$var$load("7EorR"),
    $be5cef0f24b910f3$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("eQgk5", function(module, exports) {

let $02c9d91ea7216b5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $02c9d91ea7216b5a$var$load("6FuHS"),
    $02c9d91ea7216b5a$var$load("eyaRC"),
    $02c9d91ea7216b5a$var$load("2YffH"),
    $02c9d91ea7216b5a$var$load("cf5vC"),
    $02c9d91ea7216b5a$var$load("g4Z5V"),
    $02c9d91ea7216b5a$var$load("gHOqr"),
    $02c9d91ea7216b5a$var$load("6SW0d"),
    $02c9d91ea7216b5a$var$load("6RpMD"),
    $02c9d91ea7216b5a$var$load("h4Nf7"),
    $02c9d91ea7216b5a$var$load("7f9Fz"),
    $02c9d91ea7216b5a$var$load("8YSo7"),
    $02c9d91ea7216b5a$var$load("9AHrA"),
    $02c9d91ea7216b5a$var$load("2spqH"),
    $02c9d91ea7216b5a$var$load("gWSdF"),
    $02c9d91ea7216b5a$var$load("g9CVe"),
    $02c9d91ea7216b5a$var$load("aeEUI"),
    $02c9d91ea7216b5a$var$load("iXzmH"),
    $02c9d91ea7216b5a$var$load("65c4i"),
    $02c9d91ea7216b5a$var$load("6wr18"),
    $02c9d91ea7216b5a$var$load("kjZZD"),
    $02c9d91ea7216b5a$var$load("3TTZL"),
    $02c9d91ea7216b5a$var$load("eHDb1"),
    $02c9d91ea7216b5a$var$load("2zUEf"),
    $02c9d91ea7216b5a$var$load("37ldp"),
    $02c9d91ea7216b5a$var$load("awqCy"),
    $02c9d91ea7216b5a$var$load("kHOMt"),
    $02c9d91ea7216b5a$var$load("hhss7"),
    $02c9d91ea7216b5a$var$load("aqsij"),
    $02c9d91ea7216b5a$var$load("3kIJ4"),
    $02c9d91ea7216b5a$var$load("iZU4p"),
    $02c9d91ea7216b5a$var$load("Wowvf"),
    $02c9d91ea7216b5a$var$load("dS0Pr"),
    $02c9d91ea7216b5a$var$load("huYla"),
    $02c9d91ea7216b5a$var$load("f1NVy"),
    $02c9d91ea7216b5a$var$load("2haIE"),
    $02c9d91ea7216b5a$var$load("9K4jq"),
    $02c9d91ea7216b5a$var$load("let0D"),
    $02c9d91ea7216b5a$var$load("6EQss"),
    $02c9d91ea7216b5a$var$load("6M36W"),
    $02c9d91ea7216b5a$var$load("ffEVr"),
    $02c9d91ea7216b5a$var$load("kUbUu"),
    $02c9d91ea7216b5a$var$load("9ftJe"),
    $02c9d91ea7216b5a$var$load("hUIij"),
    $02c9d91ea7216b5a$var$load("hX3A6"),
    $02c9d91ea7216b5a$var$load("lnKog"),
    $02c9d91ea7216b5a$var$load("7Omhy"),
    $02c9d91ea7216b5a$var$load("kC80R"),
    $02c9d91ea7216b5a$var$load("7EorR"),
    $02c9d91ea7216b5a$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("jBA3I"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("jBA3I", function(module, exports) {

let $e45d71962bb4081d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e45d71962bb4081d$var$load("hUIij"),
    $e45d71962bb4081d$var$load("hX3A6"),
    $e45d71962bb4081d$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.1952ebc9.js.map
